import { render, staticRenderFns } from "./ProfilePasswordInvira.vue?vue&type=template&id=ed88d4f2&"
import script from "./ProfilePasswordInvira.vue?vue&type=script&lang=js&"
export * from "./ProfilePasswordInvira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports